<template>
  <b-card title="Procesamiento de documentos">
    <div v-if="loading" class="d-flex justify-content-center align-items-center pt-5">
      <b-spinner class="mt-5" variant="primary"/>
    </div>
    <h4 v-if="fromEditAction" class="text-primary">
      Si quieres editar la metadata, realiza las modificaciones antes en el modal a continuación
      y luego edita el expediente de forma habitual.
    </h4>
    <b-modal
      ref="modalMetadata"
      size="xl"
      hide-footer
      no-close-on-backdrop
      title="Metadata del expediente"
      v-if="fromEditAction"
    >
      <Metadata
        :notify="notify"
        :fromEdit="fromEditAction"
        :justificationCompleted="justificationCompleted"
        @is-justified="setJustification"
        @close-modal="closeModalMetadata"
      />
    </b-modal>
    <div class="row my-5" v-if="fromEditAction">
      <div class="col-12 text-left">
        <vs-button
          class="mr-2 btn btn-warning"
          @click="verMetadata()"
          :disabled="loading"
          v-if="fromEditAction"
        >
          Ver metadata
        </vs-button>
      </div>
    </div>
    <hr v-if="fromEditAction">
    <form v-if="!loading" @keydown.enter.prevent autocomplete="off" data-vv-scope="inputDoc">
      <div class="row mt-3">
        <div class="col-6">
          <vs-input class="w-100" label="Código de Documento" v-model="docCode" readonly/>
        </div>
        <div class="col-6">
          <vs-input class="w-100" label="Fecha de ingreso" v-model="inputDate" readonly/>
        </div>
        <div class="col-12 mt-2">
          <ClassificationList v-model="classification"/>
          <small class="text-danger" v-if="error.clasification">{{error.clasification}}</small>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <ListDocumentTypes
            class="w-100"
            autocomplete
            label="Tipo de documento *"
            placeholder="Seleccione..."
            name="documentType"
            v-model="documentType"
            v-validate="'required'"
            ref="documentTypes"
            :danger="errors.has('inputDoc.documentType')"
            :danger-text="errors.first('inputDoc.documentType')"
          />
        </div>
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Número"
            v-model="numDoc"
            data-vv-as="número de documento"
            v-validate="'max:50'"
            name="numDoc"
            :danger="errors.has('inputDoc.numDoc')"
            :danger-text="errors.first('inputDoc.numDoc')"
            :success="!errors.has('inputDoc.numDoc') && !!numDoc"
          />
        </div>
        <div class="col-6" v-if="documentType === 'IPCAFTO'">
          <label>Comisiones</label>
          <treeselect v-model="commissions" placeholder="Seleccione..." :options="interestAreas"/>
        </div>
        <div class="col-6 mt-1" v-if="documentType === 'IPCAFTO'">
          <vs-input class="w-100" label="Cantidad de Adhesiones" v-model="adhesion"/>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-6">
          <label>Es documento madre</label>
          <b-form-select
            class="w-100"
            data-cy="mother-document"
            v-model="isMotherDocument"
            :options="isMotherOptions"
            @change="motherDocNumber = undefined"
          />
        </div>
        <div class="col-6" v-show="!isMotherDocument">
          <div class="form-group">
            <vs-input
              autocomplete="off"
              class="w-100"
              label="N° Documento Madre *"
              v-model.trim="motherDocNumber"
              data-vv-as="n° documento madre"
              v-validate="{ required: !isMotherDocument }"
              name="numDocMother"
              v-on:keyup="searchForMother()"
              @change="deleteMotherReference"
              :danger="errors.has('inputDoc.numDocMother')"
              :danger-text="errors.first('inputDoc.numDocMother')"
              :success="!errors.has('inputDoc.numDocMother') && !!motherDocNumber"
            />
            <ul id="list"
                v-if="(motherDocumentsList.length > 0 || loadingMotherDocuments) && showListSelect">
              <li v-if="loadingMotherDocuments">
                <span class="muted-light">Buscando...</span>
              </li>
              <li
                v-for="item in motherDocumentsList"
                @click="updateMotherDoc(item)"
                v-bind:key="item.numero"
              >
                <span>{{ item.numero }}</span>
                <span class="muted-light">
                  creado el {{ formatDate(item.fechaCreacion) }}
                </span>
                <p>Creado por <b>{{ item.solicitanteNombre}}</b> ({{ item.solicitanteEmail}})</p>
              </li>
            </ul>
          </div>
          <small class="text-danger" v-if="error.motherDoc">{{error.motherDoc}}</small>

        </div>
        <div class="col-6" v-if="showStateSelect">
          <vs-select
            class="w-100"
            v-model="proposalStatus"
            autocomplete
            label="Estado de la propuesta"
            placeholder="Seleccione..."
          >
            <!--<vs-select-item value="published" text="Publicado"/>
            <vs-select-item value="processed" text="Tramitado"/>-->
            <vs-select-item value="approved" text="Aprobada"/>
            <vs-select-item value="partial-approved" text="Aprobada parcial"/>
            <vs-select-item value="rejected" text="Rechazada"/>
            <vs-select-item value="retired" text="Retirada"/>
            <vs-select-item value="not-processed" text="No tramitada"/>
            <vs-select-item value="inadmissible" text="Inadmisible"/>
          </vs-select>
        </div>
        <div class="col-12 mt-3">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Nombre del expediente"
            v-model="titleExp"
            v-validate="'max:1000'"
            name="nameExp"
          />
        </div>
      </div>
      <div class="row mt-1 d-flex align-items-end">
        <div class="col-12 mt-5">
          <h6>Remitente:</h6>
        </div>
        <div class="col-12 d-flex align-items-center">
          <b-form-radio
            :disabled="fromDocDigital || (fromEditAction && categoryNumber !== 1)"
            class="ml-3 mr-5"
            @change="clearSender"
            name="search" v-model="sender" value="naturalPerson"
            data-cy="natural-person-button"
          >
            Ciudadano/a
          </b-form-radio>
          <b-form-radio
            @change="clearSender"
            :disabled="fromDocDigital || (fromEditAction && categoryNumber !== 1)"
            class="mr-5"
            name="search" v-model="sender" value="legalPerson"
            data-cy="legal-person-button"
          >
            Persona Jur&iacute;dica
          </b-form-radio>
          <b-form-radio
            @change="clearSender"
            :disabled="fromEditAction && categoryNumber !== 1"
            class="mr-5" name="search"
            v-model="sender"
            value="stateAgency"
            data-cy="state-agency-button"
          >
            Organismo del estado
          </b-form-radio>
          <b-form-radio
            @change="clearSender"
            :disabled="fromDocDigital || (fromEditAction && categoryNumber !== 2)" class="mr-5"
            name="search" v-model="sender"
            value="conventional"
            data-cy="conventional-button"
          >
            Convencional
          </b-form-radio>
          <b-form-radio
            @change="clearSender"
            :disabled="fromDocDigital || (fromEditAction && categoryNumber !== 2)" class="mr-5"
            name="search"
            v-model="sender"
            value="commission"
            data-cy="commission-button"
          >
            Comisión
          </b-form-radio>
          <b-form-radio
            @change="clearSender"
            :disabled="fromDocDigital || (fromEditAction && categoryNumber !== 2)" class="mr-5"
            name="sender" v-model="sender"
            value="user"
            data-cy="user-button"
          >
            Usuario
          </b-form-radio>
        </div>
        <div class="col-12" v-if="sender === 'stateAgency'">
          <label>Organismos del estado</label>
          <b-form-select
            :disabled="fromDocDigital" class="w-100" v-model="agency" :options="agencyOptions"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="sender === 'commission'">
        <div class="col-6">
          <list-groups
            class="w-100"
            autocomplete
            name="group"
            :block="false"
            :typeList="1"
            showOnlyCommissions
            label="Comisión"
            v-model="sendToPartsOffice"
            v-on:full-group="selectCommission"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="sender === 'conventional'">
        <div class="col-6">
          <ListUser
            class="w-100 mb-0"
            autocomplete
            label="Entrega a oficina de partes"
            name="user"
            data-cy="select-parts-office"
            v-model="sendToPartsOffice"
            ref="conventional"
            data-vv-as="usuario"
            onlyConventional
            @full-user="addUserData"
          />
        </div>
        <div class="col-6">
          <ListUser
            class="w-100 mb-0"
            autocomplete
            label="Autores"
            name="user"
            data-vv-as="usuario"
            onlyConventional
            @full-user="addAuthor"
          />
          <div>
            <ul class="d-flex mt-1">
              <li
                class="text-primary cursor-pointer mr-2 font-weight-bolder"
                v-tooltip="'Click para borrar'"
                v-for="author in authors" :key="author.usuarioAutorId"
                @click="removeAuthor(author.usuarioAutorId)"
              >
                {{`${author.usuarioAutorNombre},`}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mt-3" v-if="sender === 'user'">
        <div class="col-6">
          <ListUser
            class="w-100 mb-0"
            autocomplete
            label="Seleccione el usuario"
            name="user"
            data-cy="select-user"
            v-model="sendToPartsOffice"
            ref="conventional"
            data-vv-as="usuario"
            @full-user="addUserData"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="sender === 'stateAgency' && agency !== 'docDigital'">
        <div class="col-6">
          <vs-input autocomplete="off" class="w-100" label="Repartición" v-model="distribution"/>
        </div>
        <div class="col-6">
          <vs-input autocomplete="off" class="w-100" label="Firmante" v-model="signer"/>
        </div>
      </div>
      <DocDigitalInputs
        v-if="agency === 'docDigital'"
        :entity="entity"
        :theme="theme"
        :description="description"
        :signers="signers"
        :certifiers="certifiers"
      />
      <div class="row mt-3" v-if="sender === 'legalPerson'">
        <div class="col-12">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Representante legal"
            v-model="legalRepresentative"
            data-vv-as="representante legal"
            v-validate="'max:200'"
            name="legalRep"
            :danger="errors.has('inputDoc.legalRep')"
            :danger-text="errors.first('inputDoc.legalRep')"
            :success="!errors.has('inputDoc.legalRep')
            && legalRepresentative
            && legalRepresentative.length > 0"
          />
        </div>
      </div>
      <div class="row mt-3" v-if="sender === 'naturalPerson' || sender === 'legalPerson'">
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Rut"
            v-model="iut"
            data-vv-as="rut"
            v-validate="'validateRut'"
            name="iut"
            :danger="errors.has('inputDoc.iut')"
            :danger-text="errors.first('inputDoc.iut')"
            :success="!errors.has('inputDoc.iut') && iut.length > 0"
          />
        </div>
        <div class="col-6">
          <vs-input
            v-model="name"
            autocomplete="off"
            class="w-100"
            :label="sender === 'naturalPerson' ? 'Nombre' : 'Persona jurídica (Empresa u ONG) *'"
            :data-vv-as="sender === 'naturalPerson' ? 'nombre' : 'persona jurídica (Empresa u ONG)'"
            v-validate="'max:200'"
            name="name"
            :danger="errors.has('inputDoc.name')"
            :danger-text="errors.first('inputDoc.name')"
            :success="!errors.has('inputDoc.name') && name.length > 0"
          />
        </div>
      </div>
      <div
        class="row mt-3"
        v-if="showContactData"
      >
        <div class="col-6 d-flex align-items-end">
          <div class="w-100">
            <ListCommunes
              autocomplete="off"
              data-vv-as="comuna"
              v-model="selectedCommune"
              name="commune"
              :isClearable="false"
              :danger="errors.has('inputDoc.commune')"
              :danger-text="errors.first('inputDoc.commune')"
              :clearCommune="clearCommune"
            />
          </div>
        </div>
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Dirección"
            data-vv-as="dirección"
            name="address"
            v-model="address"
            :danger="errors.has('inputDoc.address')"
            :danger-text="errors.first('inputDoc.address')"
            :success="!errors.has('inputDoc.address') && address.length > 0"
          />
        </div>
      </div>
      <div
        class="row mt-3"
        v-if="showContactData"
      >
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Correo"
            data-vv-as="correo"
            v-validate="'email|max:100'"
            name="email"
            v-model="email"
            :danger="errors.has('inputDoc.email')"
            :danger-text="errors.first('inputDoc.email')"
            :success="!errors.has('inputDoc.email') && email.length > 0"
          />
        </div>
        <div class="col-6" v-if="!agency.match(/centralAdministration|docDigital/)">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Teléfono"
            placeholder="Escriba en formato +56912345678"
            v-model="phone"
            data-vv-as="teléfono"
            v-validate="{ regex: phoneRegex }"
            name="phone"
            :danger="errors.has('inputDoc.phone')"
            :danger-text="errors.first('inputDoc.phone')"
            :success="!errors.has('inputDoc.phone') && phone.length > 0"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <vs-input
            class="w-100"
            v-model="metadata.description"
            label="Descripción"
            data-vv-as="descripción"
            name="alternativeTitle"
          />
        </div>
        <div class="col-6">
          <vs-input
            class="w-100"
            v-model="metadata.alternativeTitle"
            label="Título alternativo"
            data-vv-as="titulo alternativo"
            name="alternativeTitle"
          />
        </div>
        <div class="col-6 mt-3">
          <vs-input
            class="w-100"
            v-model="metadata.idSaip"
            label="ID SAIP"
            data-vv-as="id Saip"
            name="idSaip"
          />
        </div>
        <div class="col-6 mt-3">
          <label>Fecha del documento</label>
          <b-form-datepicker
            locale="es"
            placeholder="Fecha del documento"
            name="documentDate"
            v-model="metadata.documentDate"
            label-help="Puede usar las flechas del teclado y espacio"
          />
        </div>
        <div class="col-6 mt-3">
          <label>Fecha de finalización</label>
          <b-form-datepicker
            locale="es"
            placeholder="Fecha de finalización"
            name="documentEndDate"
            v-model="metadata.documentEndDate"
            label-help="Puede usar las flechas del teclado y espacio"
          />
        </div>
        <div class="col-12 mt-3">
          <ListUser
            class="w-100 mb-0"
            autocomplete
            label="Autores internos"
            name="authors"
            data-vv-as="autores"
            onlyRol
            @full-user="addInternAuthor"
          />
        </div>
        <div class="col-5 mt-3">
          <vs-input
            class="w-100"
            v-model="metadata.externalAuthorName"
            label="Autores externos"
            data-vv-as="autores"
            name="authors"
          />
        </div>
        <div class="col-5 mt-3">
          <b-form-group label="Rol Autor externo">
            <v-select
              label="descripcion"
              :options="externAuthorsRoles"
              :reduce="rol => rol.valor"
              name="rolType"
              v-model="metadata.externalAuthorRol"
            />
          </b-form-group>
          <vs-input
            v-if="metadata.externalAuthorRol === 'Otro'"
            class="w-100"
            v-model="metadata.externalAuthorRolFree"
            label="Rol Autor externo"
            data-vv-as="autores"
            name="authors"
          />
        </div>
        <div class="col-2 mt-5">
          <vs-button class="mr-2 mt-5 btn btn-primary" @click="addExternalAuthor">
            Agregar
          </vs-button>
        </div>
        <div class="col-12 mt-3">
          <b-table-simple hover small v-if="metadata.internAuthors.length">
            <b-thead>
              <b-tr>
                <b-th scope="col">Nombre</b-th>
                <b-th scope="col">Rol</b-th>
                <b-th scope="col" class="text-center">Acción</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="internAuthor in metadata.internAuthors"
                :key="internAuthor.id"
              >
                <b-td>
                  <div class="d-flex align-items-center">
                    <vs-icon icon="description" size="medium" class="mr-1"/>
                    {{internAuthor['dc.contributor.name']}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input readonly class="w-100" v-model="internAuthor['dc.contributor.type']"/>
                </b-td>
                <b-td class="text-center">
                  <vs-icon
                    class="cursor-pointer"
                    icon="remove_circle_outline"
                    size="small"
                    v-tooltip="'Eliminar'"
                    color="danger"
                    @click="removeMetadataAuthor('intern', internAuthor)"
                  />
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
        <div class="col-6 mt-3">
          <b-form-group label="Unidad productora">
            <v-select
              label="label"
              :options="productionUnitOptions"
              :reduce="rol => rol.label"
              name="productionUnit"
              v-model="metadata.productionUnit"
            />
          </b-form-group>
        </div>
        <div class="col-6 mt-3" v-if="metadata.productionUnit === 'Otro'">
          <vs-input
            class="w-100"
            v-model="metadata.productionUnitOther"
            label="Unidad productora"
            data-vv-as="unidad productora"
            name="productionUnitOther"
          />
        </div>
      </div>
      <hr class="">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Destinatario</h4>
          <small class="text-danger" v-if="error.subject">{{error.subject}}</small>
          <SelectSubject @add-subject="addSubject" />
        </div>
        <div class="col-12">
          <TableSubjects :subjects="subjects"/>
          <small class="text-primary">
            Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual
          </small>
        </div>
      </div>
      <hr class="">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Con copia a</h4>
          <SelectCopy @add-copy="addCopy" />
        </div>
        <div class="col-12">
          <TableCopies :copies="copies" @removeCopy="removeCopy"/>
        </div>
      </div>
      <hr class="">
      <div class="row mt-3" v-if="typeof importedFile === 'undefined'">
        <div class="col-12 mt-2">
          <LoadFiles
            v-model="inputFormat"
            @mainFile="mainFile = $event"
            @additionalFiles="additionalFiles = $event"
            :withTrueCopy="!isPaper"
          />
          <small class="text-danger" v-if="error.onlyPdf">{{error.onlyPdf}}</small>
          <small class="text-danger pl-1" v-if="error.mainFile">{{error.mainFile}}</small>
        </div>
      </div>
      <!-- archivo automatico para cuando se exporta una aprobacion a un expediente -->
      <div class="row mt-3" v-if="typeof importedFile !== 'undefined'">
        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-3 text-center">
              <div class="text-left">
                <label>Formato de ingreso</label>
                <b-form-input
                  class="w-100"
                  value="Digital"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="col-9 text-center">
              <div class="text-left">
                <label>Nombre del documento</label>
                <b-form-input
                  class="w-100"
                  :value="importedFile.objetoNombre"
                  :disabled="true"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row mt-3" v-if="state === '9'">
        <div class="col-12">
          <vs-textarea
            label="Justificación de edición"
            class="w-100 mt-3"
            width="100%"
            v-model="justification"
            name="justification"
            height="100px"
            maxlength="900"
            counter="900"
            v-validate="{ required: state === '9', max: 2000 }"
            data-vv-as="justificación"
          />
          <div v-if="errors.first('inputDoc.justification')"
               class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
               style="height: 32px;">
          <span class="span-text-validation">
            {{errors.first('inputDoc.justification')}}
          </span>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 mt-5 text-right">
          <vs-button
            class="mr-2 btn btn-primary"
            @click="save('draft')"
            :disabled="loading"
            v-if="!importedFile && !fromEditAction"
          >
            Guardar Borrador
          </vs-button>
          <vs-button class="mr-2 btn btn-success" @click="save" :disabled="loading">
            Guardar
          </vs-button>
          <vs-progress
            class="mb-1 mt-2"
            v-if="loading"
            indeterminate
            color="primary"
          />
        </div>
      </div>
    </form>
    <Confirm
      :motherDocNumber="motherDocNumber"
      :isMotherDocument="isMotherDocument"
      :resetData="resetData"
      :dntCode="dntCode"
      :showConfirm="showConfirm"
      @closeModal="closeConfirm"
      :state="state"
      :fromEditActioon="fromEditAction"
    />
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';

import ListCommunes from '@/febos/chile/lists/components/ListCommunes';
import InterestAreas from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/InterestAreas';
import Confirm from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/Confirm';
import ListDocumentTypes from '@/febos/chile/lists/components/ListDocumentTypes';
import LoadFiles from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/LoadFiles';
import SelectSubject from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectSubject';
import SelectCopy from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectCopy';
import TableSubjects from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableCopies';
import ClassificationList from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/ClassificationList';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import InputProps from '@/febos/chile/dnt/components/wizard/companies/60100003-2/mixins/InputProps';
import DocDigitalInputs from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/DocDigitalInputs';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import Metadata from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/Metadata';

export default {
  name: 'DocumentProcessing',
  components: {
    Metadata,
    LoadFiles,
    ListDocumentTypes,
    SelectSubject,
    SelectCopy,
    TableSubjects,
    TableCopies,
    ClassificationList,
    Treeselect,
    Confirm,
    DocDigitalInputs,
    ListCommunes,
    ListUser,
    ListGroups
  },
  mixins: [RutMixin, InputProps],
  props: ['notify', 'previousRoute'],
  data() {
    return {
      justificationCompleted: false,
      interestAreas: InterestAreas,
      loadingMotherDocuments: false,
      motherDocumentsFullList: [],
      showListSelect: false,
      importedFile: undefined,
      externAuthorsRoles: []
    };
  },
  watch: {
    justification(newVal) {
      if (newVal !== '') {
        this.justification = newVal;
        this.justificationCompleted = true;
      } else {
        this.justificationCompleted = false;
      }
    },
    sender(val, oldVal) {
      if (oldVal === 'stateAgency') {
        this.agency = 'legislativePower';
      }
      this.$validator.reset();
    },
    classification(val) {
      if (this.fromEditAction) {
        return;
      }
      if (!val) this.docCode = '';
      if (val) this.docCode = `${val}-#`;
    },
    documentType(val, oldVal) {
      if (oldVal && val !== oldVal) {
        this.adhesion = null;
        this.proposalStatus = null;
        this.commissions = null;
      }
    },
    mainFile(newVal) {
      this.mainFile = newVal;
    }
  },
  computed: {
    ...mapGetters('Dnts', ['communes', 'loading', 'wizardStorage', 'detailsFile']),
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    motherDocumentsList() {
      const result = this.motherDocumentsFullList.filter(
        (x) => {
          try {
            return x.numero.includes(this.motherDocNumber);
          } catch (e) {
            return false;
          }
        }
      ).slice(0, 5);
      if (typeof result === 'undefined') return [];
      return result;
    },
    isPaper() {
      return this.inputFormat === 'paper';
    },
    isPaperAndDigital() {
      return this.inputFormat === 'paper_digital';
    },
    isDigital() {
      return this.inputFormat === 'digital';
    },
    fromDocDigital() {
      return this.$route.params.from === 'docDigital';
    },
    fromDraftTray() {
      return this.$route.params.from === 'draftTray';
    },
    fromEditAction() {
      return this.$route.params.from === 'edit';
    },
    showContactData() {
      return !this.agency.match(/centralAdministration|docDigital/)
        && this.sender !== 'conventional' && this.sender !== 'commission' && this.sender !== 'user';
    },
    showStateSelect() {
      const iniciativas = [
        'Iniciativa',
        'ININDI',
        'IPCAFTO'
      ];
      return iniciativas.includes(this.documentType);
    }
  },
  methods: {
    ...mapActions('List', ['fetchUsers']),
    ...mapActions('Dnts', [
      'createConventionDnt',
      'listDocuments',
      'editConventionDnt',
      'getFileDnt',
      'setWizardStorageFile'
    ]),
    deleteMotherReference() {
      this.references = this.references.filter((ref) => ref.codigo !== 'mother');
    },
    updateMotherDoc(item) {
      this.motherDocNumber = item.numero;
      this.showListSelect = false;

      const currentReferenceIndex = this.references.findIndex((ref) => ref.codigo === 'mother');
      if (currentReferenceIndex >= 0) {
        this.references = [
          {
            linea: 1,
            tipoDocumento: 'EXP',
            folio: item.numero,
            otraReferenciaId: item.febosId,
            codigo: 'mother',
            documentoId: item.febosId
          },
          ...this.references.slice(0, currentReferenceIndex),
          ...this.references.slice(currentReferenceIndex + 1)
        ];
        return;
      }
      this.references = [
        {
          linea: 1,
          tipoDocumento: 'EXP',
          folio: item.numero,
          otraReferenciaId: item.febosId,
          codigo: 'mother',
          documentoId: item.febosId
        },
        ...this.references
      ];
    },
    closeConfirm() {
      this.showConfirm = false;
      if (this.fromEditAction) {
        this.resetData();
        this.$router.push({ name: 'files', params: { view: 'completitudDatos' } });
      }
    },
    clearSender() {
      this.conventionalName = '';
      this.signer = '';
      this.sendToPartsOffice = '';
      this.entity = '';
      this.legalRepresentative = '';
      this.iut = '';
      this.name = '';
      this.selectedCommune = '';
      this.address = '';
      this.email = '';
      this.phone = '';
      this.agency = 'legislativePower';
      this.issuerContactName = '';
      this.issuerContactEmail = '';
      this.distribution = '';
      this.authors = [];
    },
    formatDate(fullDate) {
      const date = fullDate.split(' ')[0];
      const year = date.split('-')[0];
      const month = date.split('-')[1];
      const day = date.split('-')[2];
      const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      return `${day} de ${months[parseInt(month, 10)]}, ${year}`;
    },
    selectCommission(commission) {
      this.name = commission.label;
    },
    async searchForMother() {
      this.showListSelect = true;
      this.loadingMotherDocuments = true;
      const payload = {
        params: {
          elementosPorPagina: 5,
          pagina: 1,
          filtros: `numero$${this.motherDocNumber}|emisorRut:${this.company.iut}|estado:!!!3|estadoCodigoEstadoComprador:1|id:!!!${this.$route.query.febosId}`,
          orden: '-fechaCreacion'
        }
      };
      try {
        const res = await ioExpedientesSearch(payload);
        const that = this;
        res.data.documentos.forEach((element) => that.motherDocumentsFullList.push(element));
        const keys = ['numero$', 'fechaCreacion'];
        this.motherDocumentsFullList = this.motherDocumentsFullList.filter(
          // this basically delete duplicates, using added keys before
          ((s) => (o) => ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|')))(new Set())
        );
      } catch (e) {
        // nothing to do
      }
      this.loadingMotherDocuments = false;
    },
    async save(status) {
      if (this.justification) {
        const words = this.justification.split(' ');
        if (words.length < 3) {
          this.notify('Por favor cuéntanos más en la justificación', 'danger', 'Ups!');
          return;
        }
      }
      if (this.sender === 'conventional' || this.sender === 'user') {
        try {
          const personName = this.sendToPartsOffice
            ? this.$refs.conventional.getOption().label
            : '';
          this.conventionalName = personName;
        } catch (e) {
          this.notify('No se encontró información sobre el remitente', 'danger', 'Ups!');
          return;
        }
      }
      if (this.metadata.productionUnit === 'Otro' && !this.metadata.productionUnitOther) {
        this.notify('Por favor completa el campo de unidad productora', 'danger', 'Ups!');
        return;
      }
      const validForm = await this.validateForm();
      if (!validForm) return;

      if (!this.fromEditAction) {
        const ENTERED = 2;
        const DRAFT = 3;
        const FINISHED = 9;
        const INTERNAL = 3; // Cuando el documento es interno o se genero desde aprobaciones
        if (typeof this.importedFile === 'undefined' && +this.categoryNumber !== INTERNAL) {
          this.state = status === 'draft' ? DRAFT : ENTERED;
        } else {
          this.state = status === 'draft' ? DRAFT : FINISHED;
        }
      }

      const data = {
        destinatarios: this.getSubjects(),
        dnt: this.getDnt(this.state),
        dntDocDigitalAutores: this.authors.map((user) => ({
          usuarioAutorId: user.usuarioAutorId
        })),
        adjuntos: this.getAttachments(),
        etiquetas: [],
        metadata: this.getMetadata(),
        observaciones: this.getObservations(),
        referencias: this.getReferences(),
        dntDocDigitalParticipantes: this.getParticipants()
      };

      if (this.fromDocDigital) {
        const DOC_DIGITAL_CODE = 'DDD';
        data.dnt.receptorSucursalCodigo = DOC_DIGITAL_CODE;
      }

      const { febosId } = this.$route.query;

      let response = '';
      if (febosId) {
        data.dnt.febosId = febosId;
        response = await this.editConventionDnt(data);
      } else {
        response = await this.createConventionDnt(data);
      }

      if (!this.fromEditAction) {
        this.setWizardStorageFile({});
        this.$store.commit('Dnts/CLEAR_DETAILS');
        this.importedFile = undefined;
      } else {
        await this.loadSavedData();
      }
      this.dntCode = response.numero;
      this.showConfirm = true;
    },
    loadDataFromDocDigital() {
      const SECOND_POSITION = 1;
      this.sender = 'stateAgency';
      this.agency = 'docDigital';
      this.inputFormat = 'digital';
      this.entity = this.wizardStorage.dnt.transporteNotas;
      this.theme = this.wizardStorage.dnt.nombreDescriptivo;
      this.description = this.wizardStorage.observaciones[SECOND_POSITION].observacion;
      this.signers = this.wizardStorage.firmantes;
      this.certifiers = this.wizardStorage.visadores;
      this.documentType = this.wizardStorage.dnt.emisorCentroCostoNumero;
      this.numDoc = this.wizardStorage.dnt.numeroInt;
      this.dateOfIssue = this.wizardStorage.dnt.fechaEmision;
      this.issuerContactName = this.wizardStorage.dnt.emisorContactoNombre;
      this.issuerContactEmail = this.wizardStorage.dnt.emisorContactoEmail;
    },
    async loadSavedData() {
      await this.getFileDnt({
        febosId: this.$route.query.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        etiquetas: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si',
        docDigitalAutores: 'si',
        docDigitalParticipantes: 'si'
      });
      await this.fillDraftData();
      if (this.fromEditAction) {
        this.state = this.detailsFile.dnt.estado;
      }
      await this.$validator.reset();
    },
    verMetadata() {
      // this.setWizardStorageFile({});
      this.$refs.modalMetadata.show();
    },
    async closeModalMetadata() {
      this.$refs.modalMetadata.hide();
      await this.loadSavedData();
    },
    setJustification(justification) {
      this.justification = justification;
      this.justificationCompleted = true;
    }
  },
  created() {
    this.justificationCompleted = false;
    if (this.fromDocDigital) this.loadDataFromDocDigital();
    if (this.fromDraftTray) {
      this.setWizardStorageFile({});
      this.loadSavedData();
    }
    if (this.fromEditAction) {
      this.setWizardStorageFile({});
      this.loadSavedData();
    }
    this.fetchUsers({
      page: 1,
      limit: 9999,
      query: ''
    });
  },
  async mounted() {
    this.justificationCompleted = false;
    this.importedFile = this.$route.params.file;
    if (this.importedFile) {
      const extension = this.importedFile.objetoNombre.split('.').pop();
      const fileName = `${this.importedFile.id}.${extension}`;
      this.importedFile.path = `febos-io/chile/${process.env.VUE_APP_AMBIENTE}/archivos/aprobaciones/terceros/${fileName}`;
      this.inputFormat = 'digital';
      this.mainFile = {
        id: this.importedFile.id,
        name: this.importedFile.objetoNombre,
        mime: 'application/pdf',
        date: this.inputDate,
        path: this.importedFile.path,
        currentDescription: this.importedFile.objetoNombre
      };
      this.references = [{
        tipoDocumento: 'APR',
        folio: this.importedFile.numero,
        documentoId: this.importedFile.idAprobacion
      }];
    }
    const response = await listOptions({
      grupoOpcion: 'roles-usuarios-convencion',
      deshabilitado: 'no'
    });
    this.externAuthorsRoles = response.data.opciones;
    const states = await listOptions({
      grupoOpcion: 'estados-exp',
      deshabilitado: 'no'
    });
    this.availableStatusExp = states.data.opciones
      .map((option) => ({
        id: option.opcionId,
        label: option.descripcion,
        value: option.opcionId
      }));
  }
};
</script>
<style scoped>
#list {
  font-size: 12px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  background-color: white;
  border-radius: 0 0 5px 5px;
  border: 1px #ccc solid;
  position: absolute;
  z-index:100;

}

#list li {
  display: block;
  padding: 5px 15px;
}

#list li:hover {
  background-color: #ccc;
  /*   color: white; */
}

#list li span {
  font-weight: 550;
}

#list li p {
  margin: 5px 0 0;
}
.muted-light{
  color:#aaa;
  font-weight:100;
}
</style>
